export default __webpack_public_path__ + "static/media/landing-desktop-05.f9789cc2.png";